import React from 'react';
import Loading from '../../../_shared/components/Loading';
import { Heading, StyledLabel } from './Styles';

const PendingHeader = ({ heading, subHeading, isLoading }) => {
  return (
    <>
      <Heading testId="page-header-subheading" variant="light">
        {isLoading ? <Loading width="553px" height="24px" /> : heading}
      </Heading>
      <StyledLabel testId="page-header-caption">
        {isLoading ? <Loading width="553px" height="19px" /> : subHeading}
      </StyledLabel>
    </>
  );
};

export default PendingHeader;
